import { GetterTree } from 'vuex';
import { CustomQuestionsState, RootState } from '../types';

export const getters: GetterTree<CustomQuestionsState, RootState> = {
	getAllQuestions(state): CustomQuestion[] {
		return state.questions;
	},

	getCheckoutQuestions(state): CustomQuestion[] {
		return state.questions.filter((q) => q.type === 'checkout');
	},

	getBeoQuestions(state): CustomQuestion[] {
		return state.questions.filter((q) => q.type === 'beo');
	},

	getInquiryFormQuestions(state): CustomQuestion[] {
		return state.questions.filter((q) => q.type === 'inquiry_form');
	},

	getCustomFields(state): CustomQuestion[] {
		return state.customFields;
	},

	getCustomFieldsInitialized(state): boolean {
		return state.customFieldsInitialized;
	}
};
